// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ab29dfcd","667":"75d50b61","977":"737a3df2"}[chunkId] + ".chunk.js";
};